import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { RouteParams } from '../signature-routes';
import { Stack, Icon, Text } from '@servicetitan/design-system';

interface SuccessPageProps extends RouteComponentProps<RouteParams> {
    onCancel: () => void;
}

class SuccessPageUnwrapped extends React.PureComponent<SuccessPageProps> {
    componentDidMount() {
        setTimeout(this.closeSuccessPage, 800);
    }

    closeSuccessPage = () => {
        const { history, match, onCancel } = this.props;
        const { visitActionId } = match.params;

        onCancel();
        history.push(`/signatures/${visitActionId}`);
    };

    render() {
        return (
            <Stack direction="column" alignItems="center" className="p-y-7">
                <Icon name="check_circle" className="c-green-500" size={25} />
                <Text bold size={4} className="m-t-3">
                    Document Signed
                </Text>
            </Stack>
        );
    }
}

export const SuccessPage = withRouter(SuccessPageUnwrapped);
